import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `AccumulationSeriesDirective` directive represent a series of the react AccumulationChart.
 * It must be contained in a Pie component(`AccumulationChart`).
 * ```tsx
 * <AccumulationChartComponent>
 * <AccumulationSeriesCollectionDirective>
 * <AccumulationSeriesDirective></AccumulationSeriesDirective>
 * </AccumulationSeriesCollectionDirective>
 * </AccumulationChartComponent>
 * ```
 */
export class AccumulationSeriesDirective extends ComplexBase {
}
AccumulationSeriesDirective.moduleName = 'accumulationSeries';
AccumulationSeriesDirective.complexTemplate = { 'dataLabelTemplate': 'dataLabel.template' };
export class AccumulationSeriesCollectionDirective extends ComplexBase {
}
AccumulationSeriesCollectionDirective.propertyName = 'series';
AccumulationSeriesCollectionDirective.moduleName = 'accumulationSeriesCollection';
